import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { listLanguage } from '../../../configs/LanguageConfig';
import { getAlertMessage } from '../../helpers/Alert';
import {
  getNewsUrl,
  getRanking,
  isNotLoginOrExpired,
} from '../../helpers/Common';
import CellHover from '../../market/watchlist/summary/CellHover';
import ConfirmDelete from '../../tools/alerts/personal/ConfirmDelete';
import { topRate, typeChart } from './Const';
import Table from '../../common/table/Table';
import MiniAreaChart from './miniChart/MiniAreaChart';
import TooltipBod from './tooltip/TooltipBoD';
import HeaderTable from './headerTable/HeaderTable';
import { getColorLevelsInAssessment } from '../../helpers/Color';
import {
  getColorPrice,
  getIconPriceFollowReferencePrice,
} from '../../helpers/Color';
import ToggleSwitch from '../toggle-switch/ToggleSwitch';
import moment from 'moment';
import './STTable.scss';
import MixHeaderTitle from './headerTable/MixHeaderTitle';
import TradingViewUrl from '../../common/TradingViewUrl';
import { I18n } from 'react-redux-i18n';
import PopupRemove from '../popup-portal/popup-remove/PopupRemove';
import EventEmitter, { SHOW_GUEST_POPUP } from '../../helpers/EventEmitter';

const _format = require('string-format');
_format.extend(String.prototype, {});

class STTable extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.scrollRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { resetScrollIndex } = this.props;
    if (resetScrollIndex !== prevProps.resetScrollIndex) {
      this.scrollRef.current.scrollToTop();
    }
  }

  getClassColorText = (isSetColorText, text) => {
    return `${
      isSetColorText ? getColorLevelsInAssessment(text) : ''
    } text-overflow-eclipse`;
  };

  getIconGraph = (isIconGraph, code, text) => {
    if (isIconGraph) {
      return (
        <>
          <TradingViewUrl code={code || ''} />
          <span className="ml-5">{text}</span>
        </>
      );
    }

    return text;
  };

  renderFullTicker = (itemColumn, item, styleClassName, iconGraph) => {
    let firstValue = 0;
    let secondValue = 0;

    if (
      Array.isArray(item.rankingHistory) &&
      item.rankingHistory.length !== 1 &&
      item.rankingHistory.length
    ) {
      firstValue = item.rankingHistory[0].rankValue;
      secondValue = item.rankingHistory[1].rankValue;
    }

    const organShortName = item[itemColumn.keyOrganShortName];
    const nameAndExchange = item[itemColumn.keyNameAndExchange];

    const classColor = getColorPrice(secondValue, firstValue) + ' mr-5';
    const classIcon =
      getIconPriceFollowReferencePrice(secondValue, firstValue) + ' mr-5';
    return (
      <div className="full-ticker-detail">
        <span className={classColor}>
          <i className={classIcon} />
        </span>
        <span className={styleClassName}>{iconGraph}</span>
        <span className="full-ticker-detail-name ml-5 text-overflow-eclipse">
          {organShortName}{' '}
        </span>
        <span className="full-ticker-detail-name-exchange">
          /{nameAndExchange}{' '}
        </span>
      </div>
    );
  };

  getSchema = (i18nTitleKey, listColumn) => {
    const { colorLeft, colorRight, i18n } = this.props;
    return listColumn.map(itemColumn => {
      const key = itemColumn.key;
      const title = `${i18nTitleKey}.${key}`;
      const result = {
        key,
        title,
        thTooltip: itemColumn.thTooltip ? I18n.t(itemColumn.thTooltip) : null,
      };

      if (itemColumn.valueFromItem) {
        result.valueFromItem = itemColumn.valueFromItem;
      }

      if (key === itemColumn.key) {
        let styleDiv = {
          textAlign: itemColumn.textAlign,
          width: itemColumn.width,
          height: itemColumn.height,
        };
        const classDiv = itemColumn.isTopRate ? 'top-rate' : '';
        return {
          ...result,
          disableSort: itemColumn.isDisSort,
          isHtml: true,
          isString: itemColumn.isString,
          title: itemColumn.isDropDown ? (
            <MixHeaderTitle
              listIndustry={this.props.listIndustry}
              currentSelectedIndustryTable={
                this.props.currentSelectedIndustryTable
              }
              changeIndustryTableDropDown={
                this.props.changeIndustryTableDropDown
              }
            >
              {title}
            </MixHeaderTitle>
          ) : (
            I18n.t(title)
          ),
          thStyle: {
            textAlign: itemColumn.textAlign,
            width: itemColumn.width,
          },

          render: (text, item, width) => {
            let styleClassName = this.getClassColorText(
              itemColumn.isSetColorText,
              text,
            );
            const orgCode = item[itemColumn.keyOrgCode];
            text = itemColumn.format ? itemColumn.format(text, item) : text;
            let iconGraph = this.getIconGraph(
              itemColumn.isIconGraph,
              orgCode,
              text,
            );
            const renderText = (text, width) => {
              if (!itemColumn.isTruncate) {
                return text;
              }

              if (!width) {
                return null;
              }
              let finalText = itemColumn.isAlertMessage
                ? getAlertMessage(item, i18n.locale)
                : iconGraph;
              const plainText = finalText;
              if (itemColumn.hasNewsId && (item.newsId || item.newsEnId)) {
                const newsId =
                  i18n.locale === listLanguage.en ? item.newsEnId : item.newsId;
                const onNewsClick = e => {
                  const { user } = this.props;
                  e.preventDefault();
                  if (isNotLoginOrExpired(user)) {
                    EventEmitter.dispatch(SHOW_GUEST_POPUP);
                    return;
                  }
                  window.open(getNewsUrl(i18n.locale, newsId));
                };
                finalText = (
                  <a href="#">
                    <i className="icon-star mr-2" />
                    {finalText}
                  </a>
                );
              }

              return (
                <div
                  style={{ width: width - 20 }} //minus td padding
                  className="text-truncate"
                  title={plainText}
                >
                  {finalText}
                </div>
              );
            };

            if (itemColumn.typeTooltip) {
              const content = (
                <TooltipBod
                  scoring={item[itemColumn.key]}
                  icbName={item.icbName}
                  valueType={itemColumn.key} // value, momentum, growth, vgm etc
                  code={item[itemColumn.keyOrgCode]}
                  ticker={
                    itemColumn.keyTicker ? item[itemColumn.keyTicker] : text
                  }
                  parentRef={this.scrollRef}
                  title={renderText(iconGraph, width)}
                  colorLeft={colorLeft}
                  colorRight={colorRight}
                  typeTooltip={itemColumn.typeTooltip}
                  tooltipHeight={itemColumn.tooltipHeight}
                >
                  {itemColumn.isShowFullTicker &&
                    this.renderFullTicker(
                      itemColumn,
                      item,
                      styleClassName,
                      iconGraph,
                    )}

                  {!itemColumn.isShowFullTicker && (
                    <span className={styleClassName} style={{ width: '100%' }}>
                      {renderText(iconGraph, width)}
                    </span>
                  )}
                </TooltipBod>
              );
              return (
                <div style={styleDiv}>
                  {itemColumn.isUsingCellHover ? (
                    <CellHover
                      organCode={item.organCode}
                      isShowDeleteIcon={false}
                    >
                      {content}
                    </CellHover>
                  ) : (
                    content
                  )}
                </div>
              );
            }

            if (itemColumn.isRanking) {
              return (
                <div style={styleDiv}>
                  <span>
                    {getRanking(
                      item[itemColumn.keyRank],
                      item[itemColumn.keyTotalRank],
                    )}
                  </span>
                </div>
              );
            }

            if (itemColumn.typeChart) {
              const data = text ? [...text] : [];
              return (
                <div style={styleDiv} ref={c => (this.miniAreaChartRef = c)}>
                  {itemColumn.typeChart === typeChart.areaChart && (
                    <MiniAreaChart
                      data={data.reverse().map(item => item.rankValue)}
                      parentRef={this.miniAreaChartRef}
                    />
                  )}
                </div>
              );
            }

            if (itemColumn.isToggleSwitch) {
              return (
                <div className="text-center">
                  <ToggleSwitch
                    isActive={!!item[itemColumn.keyIsActive]}
                    handleToggle={prevActive =>
                      this.props.handleToggle(prevActive, item)
                    }
                  />
                </div>
              );
            }

            if (itemColumn.isAction) {
              return (
                <div className="text-center d-flex justify-content-around">
                  <div className="personal-action">
                    <i
                      onClick={() => this.props.handleModify(item)}
                      className="icon-pencil-edit"
                    />
                  </div>

                  <div className="personal-action">
                    <ConfirmDelete
                      handleDelete={() =>
                        this.props.objectConfirmDel.handleClickDelete(
                          '',
                          item.personalAlertId,
                        )
                      }
                    />
                  </div>
                </div>
              );
            }

            if (itemColumn.isModify) {
              return (
                <div className="text-center">
                  <i
                    onClick={() => this.props.handleModify(item)}
                    className="icon-pencil-edit"
                  />
                </div>
              );
            }

            if (itemColumn.isRemove) {
              return (
                <div className="text-center">
                  <PopupRemove
                    id={item.personalAlertId}
                    handleDelete={this.props.handleDelete}
                    {...this.props.objectConfirmDel}
                  />
                </div>
              );
            }

            if (itemColumn.key === 'createDate') {
              return (
                <div
                  style={styleDiv}
                  className={`${classDiv} font-weight-light`}
                >
                  <span className={styleClassName}>{iconGraph}</span>
                </div>
              );
            }

            if (
              itemColumn.isTopRate &&
              (text === 1 || text === 2 || text === 3)
            ) {
              let colorOvalLeft =
                text === 1
                  ? topRate.top1.colorOvalLeft
                  : text === 2
                  ? topRate.top2.colorOvalLeft
                  : topRate.top3.colorOvalLeft;
              let colorOvalRight =
                text === 1
                  ? topRate.top1.colorOvalRight
                  : text === 2
                  ? topRate.top2.colorOvalRight
                  : topRate.top3.colorOvalRight;
              let colorOvalBorder =
                text === 1
                  ? topRate.top1.colorBorder
                  : text === 2
                  ? topRate.top2.colorBorder
                  : topRate.top3.colorBorder;
              let colorBottom =
                text === 1
                  ? topRate.top1.colorBottom
                  : text === 2
                  ? topRate.top2.colorBottom
                  : topRate.top3.colorBottom;
              let styleObj = {
                backgroundImage: _format(
                  'linear-gradient(to bottom, {0}, {1})',
                  colorOvalLeft,
                  colorOvalRight,
                ),
                border: _format('solid 2px {0}', colorOvalBorder),
              };
              const idKey = 'top-rate-bottom' + moment().unix() + text;
              return (
                <div className="top-rate " style={styleDiv}>
                  <div className="top-rate-top" style={styleObj}>
                    <span className={styleClassName}>{text}</span>
                  </div>
                  <style
                    dangerouslySetInnerHTML={{
                      __html: [
                        '#' + idKey + ':after, #' + idKey + ':before {',
                        'border-color: ' +
                          colorBottom +
                          ' transparent transparent transparent',
                        '}',
                      ].join('\n'),
                    }}
                  />
                  <div className="top-rate-bottom" id={idKey} />
                </div>
              );
            }

            return (
              <div style={styleDiv} className={classDiv}>
                <span className={styleClassName}>{iconGraph}</span>
              </div>
            );
          },
        };
      }
      return result;
    });
  };

  render() {
    const {
      isLoading,
      getDataFromRedux,
      changeIdHover,
      ids,
      idHover,
      schemaKey,
      listColumn,
      isHeaderTable,
      colorLeft,
      colorRight,
      titleHeaderTable,
      isHighlight,
      handleScroll,
      onRowClick,
      onSort,
    } = this.props;
    return (
      <div className="d-flex flex-fill flex-column">
        {isHeaderTable && (
          <HeaderTable
            title={titleHeaderTable}
            colorLeft={colorLeft || null}
            colorRight={colorRight || null}
          />
        )}
        <Table
          onSort={onSort}
          clickRow={onRowClick}
          resizable={true}
          rowDraggable={false}
          scrollRef={this.scrollRef}
          isLoading={isLoading}
          getDataFromRedux={getDataFromRedux}
          onScrollFunction={handleScroll}
          ids={ids}
          isHighlight={isHighlight}
          schema={this.getSchema(schemaKey, listColumn)}
          changeIdHover={changeIdHover}
          idHover={idHover}
        />
      </div>
    );
  }
}

STTable.propTypes = {
  ids: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  i18nPrefix: PropTypes.string,
  getDataFromRedux: PropTypes.func.isRequired,
  onRowClick: PropTypes.func,
  onSort: PropTypes.func,
};

STTable.defaultProps = {
  i18nPrefix: 'stRanking',
  isLoading: false,
  onRowClick: () => {},
  onSort: () => {},
};

const mapStateToProps = state => ({
  i18n: state.i18n,
  user: state.userInfo,
});

export default connect(mapStateToProps)(STTable);
